import { defineStore } from 'pinia';

export const useWebsiteStore = defineStore('website', () => {
  const pageHiddenPoint = ref<boolean>(true);
  const disablePageAnimation = ref<boolean>(false);
  const backAnimation = ref<boolean>(false);
  const blockTabBar = ref<boolean>(false);
  const showTabBar = ref<boolean>(false);
  const isSecondaryLayout = ref<boolean>(false);
  const hydrationComplete = ref<boolean>(false);

  const _update = (value: boolean) => {
    if (value) {
      isSecondaryLayout.value = true;
      showTabBar.value = true;

    } else {
      isSecondaryLayout.value = false;
      showTabBar.value = false;
    }
  };

  watch(() => useState<boolean>('isTablet').value, (value) => _update(value));

  _update(useState<boolean>('isTablet').value);

  return {
    pageHiddenPoint,
    disablePageAnimation,
    backAnimation,
    blockTabBar,
    showTabBar,
    isSecondaryLayout,
    hydrationComplete,
  };
});
